export const DID_SHARE_ON = 'DID_SHARE_ON';

function _didShareOn(platform) {
  return { type: DID_SHARE_ON, payload: platform };
}

export const didShareOn = platform => (dispatch) => {
  return dispatch(_didShareOn(platform));
}



// WEBPACK FOOTER //
// ./src/state/actions/qualifyActions.js